import { http } from "shared/api/http";
import { IBillFormat, IEligibilityCheck } from "eligibility/models";

const basePath = (tenantId: string, organizationId: string) =>
  `${process.env.REACT_APP_API_BASE_URL}/api/v1/tenants/${tenantId}/organizations/${organizationId}/eligibility-checks`;

const requireIds = (tenantId: string, organizationId: string) => {
  if (!tenantId || !organizationId) {
    throw new Error("tenantId and organizationId are required");
  }
};

export const getFormats = async (
  tenantId: string,
  organizationId: string
): Promise<IBillFormat[]> => {
  requireIds(tenantId, organizationId);
  const { data } = await http.get<IBillFormat[]>(
    `${basePath(tenantId, organizationId)}/formats`
  );
  return data;
};

export const createCheck = async (
  tenantId: string,
  organizationId: string,
  billFormat: string,
  files: File[]
): Promise<IEligibilityCheck> => {
  requireIds(tenantId, organizationId);
  const form = new FormData();
  form.append("billFormat", billFormat);
  files.forEach((f) => form.append("files", f));
  const { data } = await http.post<IEligibilityCheck>(
    basePath(tenantId, organizationId),
    form,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data;
};

export const listChecks = async (
  tenantId: string,
  organizationId: string,
  projectId?: string
): Promise<IEligibilityCheck[]> => {
  requireIds(tenantId, organizationId);
  const { data } = await http.get<IEligibilityCheck[]>(
    basePath(tenantId, organizationId),
    { params: projectId ? { projectId } : undefined }
  );
  return data;
};

export const getCheck = async (
  tenantId: string,
  organizationId: string,
  id: string
): Promise<IEligibilityCheck> => {
  requireIds(tenantId, organizationId);
  const { data } = await http.get<IEligibilityCheck>(
    `${basePath(tenantId, organizationId)}/${id}`
  );
  return data;
};

export const attachToProject = async (
  tenantId: string,
  organizationId: string,
  id: string,
  projectId: string
): Promise<IEligibilityCheck> => {
  requireIds(tenantId, organizationId);
  const { data } = await http.post<IEligibilityCheck>(
    `${basePath(tenantId, organizationId)}/${id}/attach`,
    { projectId }
  );
  return data;
};

export const eligibilityService = {
  getFormats,
  createCheck,
  listChecks,
  getCheck,
  attachToProject,
};
